import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-right",
  "use": "icon-icon-arrow-right-usage",
  "viewBox": "0 0 20.218 12.419",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.218 12.419\" id=\"icon-icon-arrow-right\">\n    <path id=\"icon-icon-arrow-right_Path_34\" data-name=\"Path 34\" d=\"M10.83,0V5.488H0V6.932H10.83v5.486l9.388-6.209Z\" transform=\"translate(0 0)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol